module.exports = __webpack_public_path__ + "static/img/btl_logo.19cd1aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/desktop@1x/pic/events/btl_logo.png
// module id = HM7Y
// module chunks = 0